import { FullBleedCtaBgImageOrVideoI } from 'interfaces/content-stack/modular-blocks/fullBleedCta';
import { ContentAlignmentType } from 'interfaces/styles';

export const getFullBleedCtaMedia = (backgroundImageOrVideo: FullBleedCtaBgImageOrVideoI) => {
  return {
    type: backgroundImageOrVideo.featureVideo ? 'video' : 'image',
    fixedDesktopImage:
      backgroundImageOrVideo.fixedDesktopImage && backgroundImageOrVideo.featureImageDesktop?.url
        ? backgroundImageOrVideo.featureImageDesktop?.url
        : undefined,
    showMobileImageAsBackground: backgroundImageOrVideo.showImageAsBackground,
    desktop: backgroundImageOrVideo.featureVideo?.url ?? backgroundImageOrVideo.featureImageDesktop?.url,
    mobile:
      backgroundImageOrVideo.featureImageMobile?.url ??
      backgroundImageOrVideo.featureImageDesktop?.url ??
      backgroundImageOrVideo.featureVideo?.url,
  };
};

export const getRadialPosition = (contentAlignment: ContentAlignmentType) => {
  switch (contentAlignment) {
    case 'left':
      return '25% 50%';
    case 'right':
      return '75% 50%';
  }
};
